"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    type: "object",
    properties: {
        visitDate: {
            type: "number",
            format: "date",
            title: "Visit Date",
            disableFuture: true,
        },
        notes: { type: "string", title: "Notes", maxLength: 3000 },
    },
    required: ["visitDate"],
};
